import React from 'react'
import { AdminPropertyAd } from 'types'
import { Link, Typography } from '@mui/material'

interface Props {
  propertyAd: AdminPropertyAd
  matchesSM: boolean
}
function ListingAgentLink(props: Props) {
  const { propertyAd, matchesSM } = props
  return (
    <span onClick={(event) => event.stopPropagation()}>
      <Link
        href={`${process.env.REACT_APP_REDIRECT_SEARCH_APP_URL}estate-agents/el:${propertyAd?.estateAgent?.alternativeId}`}
        underline="none"
        target="_blank"
        color="black"
      >
        <Typography
          textAlign="right"
          fontSize="14px"
          sx={{ fontWeight: matchesSM ? 400 : 500, lineHeight: '16.4px' }}
          color="text.primary"
        >
          {propertyAd?.estateAgent?.companyTitle?.[0]?.text
            ? propertyAd?.estateAgent?.companyTitle?.[0]?.text
            : ''}
        </Typography>
      </Link>
    </span>
  )
}

export default ListingAgentLink
